// wp-icons — Finance (7)
import { createWpIcon } from './createIcon.js';

export const CreditCard = createWpIcon('CreditCard', [
  ['rect', { width: 20, height: 14, x: 2, y: 5, rx: 2, key: 'a' }],
  ['line', { x1: 2, x2: 22, y1: 10, y2: 10, key: 'b' }],
]);
export const Euro = createWpIcon('Euro', [
  ['path', { d: 'M4 10h12', key: 'a' }],
  ['path', { d: 'M4 14h9', key: 'b' }],
  ['path', { d: 'M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2', key: 'c' }],
]);
export const DollarSign = createWpIcon('DollarSign', [
  ['line', { x1: 12, x2: 12, y1: 2, y2: 22, key: 'a' }],
  ['path', { d: 'M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6', key: 'b' }],
]);
export const Wallet = createWpIcon('Wallet', [
  ['path', { d: 'M19 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4', key: 'a' }],
  ['path', { d: 'M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4', key: 'b' }],
  ['path', { d: 'M18 12a2 2 0 0 0 0 4h4v-4z', key: 'c' }],
]);
export const PiggyBank = createWpIcon('PiggyBank', [
  ['path', { d: 'M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8.4 3.2 1 4.2V17a2 2 0 0 0 4 0v-.5c.5.1 1 .2 1.5.2s1 0 1.5-.2V17a2 2 0 1 0 4 0v-1.8c1.2-1 2-2.5 2-4.2 0-.4-.1-.8-.1-1.2.7-.1 1.1-.8 1.1-1.5V7c0-1.1-.9-2-2-2z', key: 'a' }],
  ['path', { d: 'M2 9v1c0 1.1.9 2 2 2h1', key: 'b' }],
  ['path', { d: 'M16 11h.01', key: 'c' }],
]);
export const Receipt = createWpIcon('Receipt', [
  ['path', { d: 'M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z', key: 'a' }],
  ['path', { d: 'M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8', key: 'b' }],
  ['path', { d: 'M12 17.5v-11', key: 'c' }],
]);
export const Calculator = createWpIcon('Calculator', [
  ['rect', { width: 16, height: 20, x: 4, y: 2, rx: 2, key: 'a' }],
  ['line', { x1: 8, x2: 16, y1: 6, y2: 6, key: 'b' }],
  ['line', { x1: 16, x2: 16, y1: 14, y2: 18, key: 'c' }],
  ['path', { d: 'M16 10h.01', key: 'd' }],
  ['path', { d: 'M12 10h.01', key: 'e' }],
  ['path', { d: 'M8 10h.01', key: 'f' }],
  ['path', { d: 'M12 14h.01', key: 'g' }],
  ['path', { d: 'M8 14h.01', key: 'h' }],
  ['path', { d: 'M12 18h.01', key: 'i' }],
  ['path', { d: 'M8 18h.01', key: 'j' }],
]);
export const Sigma = createWpIcon('Sigma', [
  ['path', { d: 'M18 7V4H6l6 8-6 8h12v-3', key: 'a' }],
]);
